import { render } from "./AlertComponent.vue?vue&type=template&id=61f99c80"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/schiavon/Documentos/Projects/RESTRICTED_WP/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__